import { render } from "./EventCard.vue?vue&type=template&id=c985a51a&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=c985a51a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c985a51a"

export default script